declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

let installed = false;

export const installCallTracking = () => {
  if (typeof document === "undefined" || installed) return;
  installed = true;
  document.addEventListener("click", (e) => {
    const link = (e.target as Element | null)?.closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
    if (!link || !window.gtag) return;
    const phone_number = decodeURIComponent(link.getAttribute("href")!.slice(4));
    window.gtag("event", "call", { phone_number });
  });
};
